import { get, httpDelete, post } from "@app/common/api";
import { parseIntegrationStatuses } from "@app/common/api/apiClient/parsers/integrations";
import type {
  ApiIntegrationsSyncRequestBody,
  ApiProductivityIntegrationStatus,
} from "@app/common/types";

import * as slack from "./slack";
import * as teams from "./teams";
import * as webhooks from "./webhooks";
import * as zapier from "./zapier";

/** Shortcut method to enable an integration without going through the auth flow.
 * If the user *needs* to reauth, this will throw a 403 */
export const enableIntegration = async (url: string | null) => {
  if (!url) {
    throw new Error("Attempted to enable integration without a defined URL");
  }

  return post(url, {}, { withCreds: true });
};

export const listIntegrationStatuses = async () => {
  const response: ApiProductivityIntegrationStatus[] = await get(
    "/integrations/pai-status",
    { withCreds: true }
  );
  return parseIntegrationStatuses(response ?? []);
};

export const disconnectIntegration = async (
  url: string | null
): Promise<void> => {
  if (!url) {
    throw new Error("Attempted to delete integration without a defined URL");
  }

  return httpDelete(url, { withCreds: true });
};

export const postSyncIntegration = async (
  body: ApiIntegrationsSyncRequestBody
): Promise<void> => post("/integrations/sync", body, { withCreds: true });

const integrations = {
  enableIntegration,
  listIntegrationStatuses,
  disconnectIntegration,
  postSyncIntegration,
  slack,
  teams,
  webhooks,
  zapier,
};

export default integrations;
